<template>
<div class="ActivityUser">
    <UserList :param="param" :flag="flag"></UserList>
</div>
</template>

<script>
import UserList from 'views/tools/nationalDistribution/user/UserList.vue'
export default {
    name: 'ActivityUser',
    data() {
        return {
            param: {
                eventinnerid: this.$route.query.id ? this.$route.query.id : '',
                keywords: '',
                chname: this.$route.query.chname ? this.$route.query.chname : '',
                title: this.$route.query.title ? this.$route.query.title : '',
                isheader: ''
            },
            flag: true
        }
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {
        UserList
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ActivityUser {
}
</style>
